/**
 * TanStack Query client. Wired up in src/index.js.
 *
 * Defaults:
 *  - 30s stale time for queries
 *  - No refetch on window focus (chatozy for an e-com SPA; we want stable UI)
 *  - Retry: never on 4xx (they won't succeed), up to 2x on 5xx / network
 *  - Mutations: surface a sonner toast on error so the user always sees it
 */
import { QueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error?.status >= 400 && error?.status < 500) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      onError: (err) => {
        // 409s on cart mutations are auto-healed by the cart context
        // (the Cart-Token in sessionStorage is stale — the mutation's
        // onError clears it and refetches a fresh cart). Don't toast
        // the "Cart item does not exist" message; the user will see
        // the cart refresh instead.
        if (err?.status === 409) return;
        const message = err?.message || 'Something went wrong';
        toast.error(message);
      },
    },
  },
});
